import { useState } from 'react';
import { PlayCircle } from '@phosphor-icons/react';
import { Button } from '@/components/ui/button';
import { HowItWorksDialog } from './HowItWorksDialog';

/**
 * "Veja como funciona" no cabeçalho da vitrine (a partir de `sm`).
 *
 * Texto, e não ícone, de propósito: é o único convite do cabeçalho que a
 * pessoa não conhece de outros sites — sacola e pedidos se explicam pelo
 * desenho; "como funciona" precisa dizer o nome. Em primário e negrito para
 * ler como convite, não como mais um controle.
 */
export function HowItWorksButton() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        variant="ghost"
        size="sm"
        onClick={() => setOpen(true)}
        className="font-bold text-primary hover:text-primary"
      >
        <PlayCircle weight="fill" aria-hidden />
        Veja como funciona
      </Button>
      <HowItWorksDialog open={open} onOpenChange={setOpen} source="header" />
    </>
  );
}

/**
 * A mesma ação como linha do menu do celular. O diálogo abre POR CIMA do
 * painel, que fica aberto atrás: fechar o painel desmontaria este componente
 * e, com ele, o diálogo.
 */
export function HowItWorksMenuRow() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="flex min-h-11 w-full items-center gap-3 rounded-lg px-3 py-2 text-left transition-colors hover:bg-muted"
      >
        <PlayCircle
          size={20}
          weight="fill"
          className="shrink-0 text-primary"
          aria-hidden
        />
        <span className="min-w-0 flex-1">
          <span className="block text-base font-bold text-primary">
            Veja como funciona
          </span>
          <span className="block text-sm text-muted-foreground">
            O vídeo de apresentação, para rever quando quiser
          </span>
        </span>
      </button>
      <HowItWorksDialog
        open={open}
        onOpenChange={setOpen}
        source="mobile_menu"
      />
    </>
  );
}
